import { selectAuthToken } from 'redux/Auth/auth.selectors'
import { useAppSelector } from 'redux/hooks'
import { useNavigate } from 'react-router-dom'
import { LOGIN_ROUTE } from 'helpers/Constants/path'
import { useEffect } from 'react'
import { useFetchPermission } from 'components/Core/Permissions'

const PrivateRoutes = (props) => {
  const navigate = useNavigate()
  const authToken = useAppSelector(selectAuthToken)
  useFetchPermission()

  useEffect(() => {
    if (!authToken) {
      // not logged in so redirect to login page with the return url
      navigate(LOGIN_ROUTE, { replace: true })
    }
  }, [authToken, navigate])

  // authorized so return component
  return props.children
}

export default PrivateRoutes
